// extracted by mini-css-extract-plugin
export default {"paragraph":"texts-styles_paragraph__tqzfM"};